import { SalesOrderItem } from "../../../types";

export const formatOrderItems = (salesOrderItems: SalesOrderItem[]) => {
	// Separate standalone items and bundles
	const standaloneItems = salesOrderItems?.filter(
		(orderItem) => orderItem?.bundleItem === null || !orderItem?.bundleItem
	);

	const bundles = salesOrderItems?.filter(
		(orderItem) => orderItem?.bundleItem !== null
	);

 
	return {
		standaloneItems,
		bundles,
	};
};
